import { Link } from 'react-router'

import { BrandLogo } from '@/components/BrandLogo'
import { SURFACE_CLASS } from '@/components/Surface'
import { Button } from '@/components/ui/button'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { cn } from '@/lib/utils'

/** A link that goes nowhere: the sign-in pages' card, centred on the canvas, with a way back. */
export const NotFoundPage = () => {
  useDocumentTitle('Page not found')
  return (
    <main className="flex min-h-svh items-center justify-center bg-background px-4 py-6">
      <div
        data-slot="surface"
        className={cn(
          SURFACE_CLASS,
          'flex w-full max-w-md flex-col items-center gap-6 text-center motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-1 motion-safe:duration-300 motion-safe:ease-fluid',
        )}
      >
        <BrandLogo variant="mark" className="size-10" />
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-medium tracking-tight">This page doesn’t exist</h1>
          <p className="text-sm text-muted-foreground">The link may be old, or the page has moved.</p>
        </div>
        <Button asChild size="lg">
          <Link to="/">Go to RowCall</Link>
        </Button>
      </div>
    </main>
  )
}
